import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowleft",
  "use": "icon-arrowleft-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrowleft\"><path d=\"M682.667 196.267l-34.134-34.134c-8.533-8.533-17.066-8.533-25.6 0l-332.8 341.334c-8.533 0-8.533 8.533 0 17.066l332.8 341.334c8.534 8.533 17.067 8.533 25.6 0l34.134-25.6c8.533-17.067 8.533-25.6 0-34.134L409.6 512c-8.533-8.533-8.533-17.067 0-25.6l273.067-281.6c8.533 8.533 8.533-8.533 0-8.533z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol